/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Many features may have a comparison to some value
 * @export
 * @interface Comparison
 */
export interface Comparison {
    /**
     * Comparison name
     * @type {string}
     * @memberof Comparison
     */
    name?: string;
    /**
     * Comparison is enables or not
     * @type {boolean}
     * @memberof Comparison
     */
    enabled?: boolean;
}

/**
 * Check if a given object implements the Comparison interface.
 */
export function instanceOfComparison(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ComparisonFromJSON(json: any): Comparison {
    return ComparisonFromJSONTyped(json, false);
}

export function ComparisonFromJSONTyped(json: any, ignoreDiscriminator: boolean): Comparison {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'enabled': !exists(json, 'enabled') ? undefined : json['enabled'],
    };
}

export function ComparisonToJSON(value?: Comparison | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'enabled': value.enabled,
    };
}

